module.exports = __webpack_public_path__ + "img/loading.cdbe4e2c.gif";